const WeatherRiskLimitations = ({ limitations, disclaimer }) => {
  if (!limitations?.length && !disclaimer) {
    return null;
  }

  return (
    <section className="weather-risk-limitations">
      {disclaimer ? <p className="weather-risk-limitations__disclaimer">{disclaimer}</p> : null}
      {limitations?.length ? (
        <ul>
          {limitations.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
};

export default WeatherRiskLimitations;
